import Icon from '@cx-web/icons';

import styles from './FairPlayWithTagLine.module.scss';

export const FairPlayWithTagLine = () => {
  return (
    <div className={styles.fairPlayWithTagLine}>
      <span className={styles.tagLine}>Proudly part of:</span>
      <Icon className={styles.fairPlayLogo} icon="FairPlayLogo" />
    </div>
  );
};
